export const GIFT_CARD = {
  GET_GIFT_CARD: 'GET_GIFT_CARD',
}
